import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

/** Refs **/

export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorDialog',
  setup(__props, { expose: __expose }) {

const display = ref(false);
const message = ref('');

/** Methods **/
const open = (obj: { message: string }): void => {
  message.value = obj.message;
  display.value = true;
};

const close = (): void => {
  display.value = false;
};

const onPushCloseBtn = (): void => {
  close();
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: display.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((display).value = $event)),
    color: "error",
    timeout: 10000
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, _mergeProps({
        icon: "",
        theme: "dark"
      }, _ctx.$attrs, { onClick: onPushCloseBtn }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("close")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_alert, { type: "error" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(message.value), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})